// import { queryWaterProviderWithDocs } from "./api";
// import { PROVIDER_FIELDS, QUERY_URL_AND } from "./constants";
import { fetchProviderByIds } from "./fetchProviderByIds";
import { WaterProvider } from "./types";

export const fetchProviderById = async (adminId: string): Promise<WaterProvider> => {
    const _providers = await fetchProviderByIds([adminId]);

    return _providers?.[0];

    // const solrQuery = _.join(
    //     ["q=*:*", "rows=1", `fq=pure_strings_admin_id:"${adminId}"`, `fl=${PROVIDER_FIELDS}`],
    //     QUERY_URL_AND
    // );

    // const res = await queryWaterProviderWithDocs(solrQuery);
    // return res?.[0];
};
